import React, {useState, useEffect, useRef, useLayoutEffect, useContext} from 'react';
import AppContext from '../hooks/AppContext'

import BuDetalhe from './BuDetalhe'

import classNames from 'classnames';

const ListaPendencias = (props) => {

  const { setLoading} = useContext(AppContext);

  const secoesRef = useRef();
   
  const [skeletonShow, setSkeletonShow] = useState(true)  


  //Controle de Loading e Skeleton
  useLayoutEffect(() => {

    //Desativa o loading
    setLoading(false)
    
    //timeout do skeleton caso não tenha resposta do firebase
    setTimeout(()=> setSkeletonShow(false),5000);

  },[]);

  useEffect(() => { 
    
    //se totalização encontrada desabilita skeleton
    if(props?.secoesPendentes){
      setSkeletonShow(false);
    }

    //se totalização retornou nula do firbase desabilita o skeleton
    if(props?.secoesPendentes===null){
      setTimeout(()=> setSkeletonShow(false),100);
    }

  }, [props?.secoesPendentes]);

  const renderSkeletons = (num) =>{    
    return( 
      Array.from({length: num}, (v, i) => i).map(item =>{                  
        return <BuDetalhe key={item} skeleton/>
      })
    );
  }
  
  const wrapContainer = classNames("container-dado bloco-dados flex secoes-container align-content-start gap-vhw scroolable",{
    "align-items-center align-content-center": !props?.secoesPendentes && !skeletonShow,
    " flex-wrap align-content-start ": props?.secoesPendentes
  })

  return (
      <div ref={secoesRef} className={wrapContainer}>                       
            
            {!props?.secoesPendentes?
                skeletonShow?
                  renderSkeletons(2)
                :
                  <div className="container-dado-alt">Nenhuma Pendência Encontrada</div>                             
              
              :
                props?.secoesPendentes?.map( item => {
                  return <BuDetalhe key={item?.id} dados={item?.conteudo} resolvido={item?.valido} dataHora={item?.dataHora}/>
                })
            }
      </div>
  )
}

export default ListaPendencias;    

